import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ResetPasswordPopup from "../popupPages/ResetPasswordPopup";

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const triggerRef = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      setTimeout(() => triggerRef.current?.click(), 300);
    }
    const modalEl = document.getElementById("resetPasswordModal");
    if (!modalEl) return;
    const handleHidden = () => navigate("/");
    modalEl.addEventListener("hidden.bs.modal", handleHidden);
    return () => modalEl.removeEventListener("hidden.bs.modal", handleHidden);
  }, [token]);

  return (
    <>
      <button
        ref={triggerRef}
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#resetPasswordModal"
      />
      <ResetPasswordPopup token={token} />
    </>
  );
}

export default ResetPasswordPage;
